import { LocalDate } from "@flockcover/flock-svc-core-types"
import { useState } from "react"
import { updateQueryStringParams } from "./queryStringHelpers"

const decodeOrNull = (param?: string | null) => {
  if (param === null || param === undefined) return null
  return decodeURIComponent(param)
}

export const useQueryStringWithStateHook = (
  key: string | number | LocalDate | null | undefined,
  defaultValue?: string
): [string | null, (newValue: string) => void] => {
  const params = new URLSearchParams(window.location?.search)
  const initialValue = decodeOrNull(params.get(key as string))
  const [value, setValue] = useState((initialValue || defaultValue) ?? null)

  const setValueAndQueryString = (newValue: string) => {
    updateQueryStringParams({ [key as string]: newValue }, window.location)
    setValue(newValue ?? null)
  }

  return [value, setValueAndQueryString]
}
